import React from "react";
import { io, Socket } from "socket.io-client";


export interface GameSocketContextProps{
    gameSocket?: Socket;
}

const GameSocketContext = React.createContext<GameSocketContextProps>({
    //gameSocket: io()
})

export function useGameSocket(){
    return React.useContext(GameSocketContext)
}


export const GameSocketProvider: React.FC<any> = ({ children })=>{

    // Ref
    const socketRef = React.useRef<Socket>(io(process.env.REACT_APP_SOCKET_URL || '', {
        transports: [ 'websocket', 'polling' ]  
    }));

    return(
        <GameSocketContext.Provider
            value={{
                gameSocket: socketRef.current
            }}
        >
            { children }
        </GameSocketContext.Provider>

    )
}